getRandom = (num, min = 0) ->
  Math.floor Math.random() * ((num - min) + 1) + min

module.exports =

  toAngle: (num) ->
    (Math.PI / 180) * num

  getRandom: (num, min = 0) ->
    getRandom num, min

  getDir: ->
    if getRandom(1) then 1 else -1

  getHypotenuse: (base, angle) ->
    base / Math.sin(angle)

  getHeight: (base, angle) ->
    base * Math.tan(angle)



// WEBPACK FOOTER //
// ./webpack/requires/components/math.coffee